import * as React from 'react'
import { CollAccess, CollParameters, ExistingNetworks } from './MainCSoftAccess';
import { Checkbox, Typography } from 'antd';
import { CSSProperties } from 'react';
declare var $: any

interface IProps {
    collaborators: CollParameters[]
    collaboratorsAccesses: CollAccess[]
    setCollaboratorsAccesses: React.Dispatch<React.SetStateAction<CollAccess[]>>
    existingNetworks: ExistingNetworks
}

export default function CCustomAccess(props: IProps) {

    React.useEffect(() => {
        const newCollaboratorsAccess: CollAccess[] = props.collaborators.map((collaborator: CollParameters) => {
            const collaboratorAccess = props.collaboratorsAccesses.find(secondObj => secondObj.coll_id === collaborator.coll_id)
            if (!collaboratorAccess) {
                return  {
                    coll_id: collaborator.coll_id,
                    val_animation: false,
                    val_developpement: false,
                    val_developpement_modif: false
                } as CollAccess
            }
            else {
                return collaboratorAccess
            }
        })
        props.setCollaboratorsAccesses(newCollaboratorsAccess)
    }, [props.collaborators])

    /* Handles change in the array collaboratorAccesses depending on the checkboxes checked */
    function handleCheck(animationOrExpansionOrExpansionModif: string, idColl: string | undefined, checkValue: boolean, checkAll?: boolean) {
        let newCollaboratorsAccesses: CollAccess[] = [...props.collaboratorsAccesses]
        const newValAnimationOrExpansion: ExistingNetworks = ({
            network1: false,
            network2: false,
            network3: false,
            network4: false,
            network5: false
        })
        props.collaboratorsAccesses.map((collAccess: CollAccess, index: number) => {
            if (collAccess.coll_id !== "" && (collAccess.coll_id === idColl || checkAll)) {
                {/* Update the checkboxes for the accesses : if "check all" for animation or expansion --> all the checkboxes are checked for animation or expansion */ }
                if (animationOrExpansionOrExpansionModif.includes("animation")) {
                    if (animationOrExpansionOrExpansionModif !== "animation") {
                        const idNetwork = animationOrExpansionOrExpansionModif.slice(9) /* Get the number that identify the network column */
                        const networkKey = 'network' + idNetwork as keyof ExistingNetworks
                        /* Modify or create an access to animation for the secondary networks in the newCollaboratorsAccesses array for the collaborator (coll_id) */
                        newCollaboratorsAccesses[index] = {
                            ...newCollaboratorsAccesses[index],
                            val_animation_secondary_networks:
                                newCollaboratorsAccesses[index].val_animation_secondary_networks !== undefined
                                    ?
                                    {
                                        ...newCollaboratorsAccesses[index].val_animation_secondary_networks!,
                                        [networkKey]: checkValue,
                                    }
                                    :
                                    {
                                        ...newValAnimationOrExpansion,
                                        [networkKey]: checkValue
                                    }
                        }
                    } else if (animationOrExpansionOrExpansionModif == "animation") {
                        newCollaboratorsAccesses[index] = {
                            ...newCollaboratorsAccesses[index],
                            val_animation: checkValue
                        }
                    }
                } else if (animationOrExpansionOrExpansionModif.includes("expansionModif")) {
                    if (animationOrExpansionOrExpansionModif !== "expansionModif") {
                        const idNetwork = animationOrExpansionOrExpansionModif.slice(14)
                        const networkKey = 'network' + idNetwork as keyof ExistingNetworks
                        newCollaboratorsAccesses[index] = {
                            ...newCollaboratorsAccesses[index],
                            val_developpement_secondary_networks_modif:
                                newCollaboratorsAccesses[index].val_developpement_secondary_networks_modif !== undefined
                                    ?
                                    {
                                        ...newCollaboratorsAccesses[index].val_developpement_secondary_networks_modif!,
                                        [networkKey]: checkValue,
                                    }
                                    :
                                    {
                                        ...newValAnimationOrExpansion,
                                        [networkKey]: checkValue
                                    }
                        }
                    } else if (animationOrExpansionOrExpansionModif == "expansionModif") {
                        newCollaboratorsAccesses[index] = {
                            ...newCollaboratorsAccesses[index],
                            val_developpement_modif: checkValue
                        }
                    }
                } else if (animationOrExpansionOrExpansionModif.includes("expansion")) {
                    if (animationOrExpansionOrExpansionModif !== "expansion") {
                        const idNetwork = animationOrExpansionOrExpansionModif.slice(9)
                        const networkKey = 'network' + idNetwork as keyof ExistingNetworks
                        newCollaboratorsAccesses[index] = {
                            ...newCollaboratorsAccesses[index],
                            val_developpement_secondary_networks:
                                newCollaboratorsAccesses[index].val_developpement_secondary_networks !== undefined
                                    ?
                                    {
                                        ...newCollaboratorsAccesses[index].val_developpement_secondary_networks!,
                                        [networkKey]: checkValue,
                                    }
                                    :
                                    {
                                        ...newValAnimationOrExpansion,
                                        [networkKey]: checkValue
                                    }
                        }
                    } else if (animationOrExpansionOrExpansionModif == "expansion") {
                        newCollaboratorsAccesses[index] = {
                            ...newCollaboratorsAccesses[index],
                            val_developpement: checkValue
                        }
                    }
                }
            }
        })
        props.setCollaboratorsAccesses(newCollaboratorsAccesses)
    }

    const collaboratorsColumnWidth = ($('#div_table_content').width() as number) * 0.25
    const rowStyle: CSSProperties = {
        height: '30px',
        whiteSpace: 'normal',
        wordWrap: 'break-word',
    }
    const firstColumnStyle: CSSProperties = {
        width: collaboratorsColumnWidth + 'px',
        position: 'sticky',
        left: 0,
        zIndex: 1,
        backgroundColor: '#fff'
    }

    return (
        <div id="div_table_content" style={{ width: '100%', overflowX: 'auto' }}>
            <table style={{ width: '100%', tableLayout: 'fixed', maxWidth: '100%', borderCollapse: 'collapse' }}>
                <thead>
                    <tr style={{ height: '40px', verticalAlign: 'baseline' }}>
                        <th style={firstColumnStyle}></th>
                        <th style={{ width: '160px', textAlign: 'center' }}>Animation</th>
                        {/* Create a new column for all the networks that exists (file_id not null or undefined) for this conquest soft access */}
                        {['1', '2', '3', '4', '5'].map((idNetwork: string) => {
                            if (props.existingNetworks['network' + idNetwork as keyof ExistingNetworks]) {
                                return (
                                    <th key={`animation_${idNetwork}`} style={{ width: '160px', textAlign: 'center' }}>
                                        Animation<br />Réseau secondaire {idNetwork}
                                    </th>
                                )
                            }
                        })}
                        <th style={{ width: '160px', textAlign: 'center' }}>Expansion</th>
                        <th style={{ width: '160px', textAlign: 'center' }}>Expansion modif</th>
                        {['1', '2', '3', '4', '5'].map((idNetwork: string) => {
                            if (props.existingNetworks['network' + idNetwork as keyof ExistingNetworks]) {
                                return (
                                    <>
                                        <th key={`expansion_${idNetwork}`} style={{ width: '160px', textAlign: 'center' }}>
                                            Expansion<br />Réseau secondaire {idNetwork}
                                        </th>
                                        <th key={`expansionModif_${idNetwork}`} style={{ width: '160px', textAlign: 'center' }}>
                                            Expansion<br />Réseau secondaire {idNetwork} modif
                                        </th>
                                    </>
                                )
                            }
                        })}
                    </tr>
                </thead>
                <tbody>
                    <tr style={rowStyle}>
                        {/* "Check all" checkboxes for each column */}
                        <td style={firstColumnStyle}><b>Tout sélectionner</b></td>
                        <td style={{ textAlign: 'center' }}>
                            <Checkbox
                                style={{ marginLeft: '10px' }}
                                checked={props.collaboratorsAccesses[0]?.val_animation ?? false}
                                onChange={(e) => {
                                    handleCheck("animation", undefined, e.target.checked, true)
                                }}
                            />
                        </td>
                        {['1', '2', '3', '4', '5'].map((idNetwork: string) => {
                            if (props.existingNetworks['network' + idNetwork as keyof ExistingNetworks]) {
                                return (
                                    <td key={`select_all_animation${idNetwork}`} style={{ textAlign: 'center' }}>
                                        <Checkbox
                                            style={{ marginLeft: '10px' }}
                                            checked={props.collaboratorsAccesses[0]?.val_animation_secondary_networks?.['network' + idNetwork as keyof ExistingNetworks] ?? false}
                                            onChange={(e) => {
                                                handleCheck("animation" + idNetwork, undefined, e.target.checked, true)
                                            }}
                                        />
                                    </td>
                                )
                            }
                        })}
                        <td style={{ textAlign: 'center' }}>
                            <Checkbox
                                style={{ marginLeft: '10px' }}
                                checked={props.collaboratorsAccesses[0]?.val_developpement ?? false}
                                onChange={(e) => {
                                    handleCheck("expansion", undefined, e.target.checked, true)
                                }}
                            />
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            <Checkbox
                                style={{ marginLeft: '10px' }}
                                checked={props.collaboratorsAccesses[0]?.val_developpement_modif ?? false}
                                onChange={(e) => {
                                    handleCheck("expansionModif", undefined, e.target.checked, true)
                                }}
                            />
                        </td>

                        {['1', '2', '3', '4', '5'].map((idNetwork: string) => {
                            if (props.existingNetworks['network' + idNetwork as keyof ExistingNetworks]) {
                                return (
                                    <>
                                        <td key={`select_all_expansion${idNetwork}`} style={{ textAlign: 'center' }}>
                                            <Checkbox
                                                style={{ marginLeft: '10px' }}
                                                checked={props.collaboratorsAccesses[0]?.val_developpement_secondary_networks?.['network' + idNetwork as keyof ExistingNetworks] ?? false}
                                                onChange={(e) => {
                                                    handleCheck("expansion" + idNetwork, undefined, e.target.checked, true)
                                                }}
                                            />
                                        </td>
                                        <td key={`select_all_expansionModif${idNetwork}`} style={{ textAlign: 'center' }}>
                                            <Checkbox
                                                style={{ marginLeft: '10px' }}
                                                checked={props.collaboratorsAccesses[0]?.val_developpement_secondary_networks_modif?.['network' + idNetwork as keyof ExistingNetworks] ?? false}
                                                onChange={(e) => {
                                                    handleCheck("expansionModif" + idNetwork, undefined, e.target.checked, true)
                                                }}
                                            />
                                        </td>
                                    </>
                                )
                            }
                        })}
                    </tr>
                    {/* Create a row for each collaborator */}
                    {props.collaborators.map((collaborator: CollParameters, idColl: number) => {
                        const collaboratorAccess = props.collaboratorsAccesses.find(secondObj => secondObj.coll_id === collaborator.coll_id) || {
                            "coll_id": collaborator.coll_id,
                            "val_animation": false,
                            "val_developpement": false,
                            "val_developpement_modif": false
                        }
                        /* if(collaboratorAccess){ */
                        return (
                            <tr key={idColl} style={rowStyle}>
                                <td style={firstColumnStyle}>{collaborator.name}</td>
                                <td style={{ textAlign: 'center' }}>
                                    <Checkbox
                                        style={{ marginLeft: '10px' }}
                                        checked={collaboratorAccess?.val_animation}
                                        onChange={(e) => {
                                            handleCheck("animation", collaborator.coll_id, e.target.checked)
                                        }}
                                    />
                                </td>
                                {['1', '2', '3', '4', '5'].map((idNetwork: string) => {
                                    if (props.existingNetworks['network' + idNetwork as keyof ExistingNetworks]) {
                                        return (
                                            <td key={`select_animation${idNetwork}`} style={{ textAlign: 'center' }}>
                                                <Checkbox
                                                    style={{ marginLeft: '10px' }}
                                                    checked={collaboratorAccess?.val_animation_secondary_networks?.['network' + idNetwork as keyof ExistingNetworks]}
                                                    onChange={(e) => {
                                                        handleCheck("animation" + idNetwork, collaborator.coll_id, e.target.checked)
                                                    }}
                                                />
                                            </td>
                                        )
                                    }
                                })}
                                <td style={{ textAlign: 'center' }}>
                                    <Checkbox
                                        style={{ marginLeft: '10px' }}
                                        checked={collaboratorAccess?.val_developpement}
                                        onChange={(e) => {
                                            handleCheck("expansion", collaborator.coll_id, e.target.checked)
                                        }}
                                    />
                                </td>
                                <td style={{ textAlign: 'center' }}>
                                    <Checkbox
                                        style={{ marginLeft: '10px' }}
                                        checked={collaboratorAccess?.val_developpement_modif}
                                        onChange={(e) => {
                                            handleCheck("expansionModif", collaborator.coll_id, e.target.checked)
                                        }}
                                    />
                                </td>
                                {['1', '2', '3', '4', '5'].map((idNetwork: string) => {
                                    if (props.existingNetworks['network' + idNetwork as keyof ExistingNetworks]) {
                                        return (
                                            <>
                                                <td key={`select_expansion${idNetwork}`} style={{ textAlign: 'center' }}>
                                                    <Checkbox
                                                        style={{ marginLeft: '10px' }}
                                                        checked={collaboratorAccess?.val_developpement_secondary_networks?.['network' + idNetwork as keyof ExistingNetworks]}
                                                        onChange={(e) => {
                                                            handleCheck("expansion" + idNetwork, collaborator.coll_id, e.target.checked)
                                                        }}
                                                    />
                                                </td>
                                                <td key={`select_expansionModif${idNetwork}`} style={{ textAlign: 'center' }}>
                                                    <Checkbox
                                                        style={{ marginLeft: '10px' }}
                                                        checked={collaboratorAccess?.val_developpement_secondary_networks_modif?.['network' + idNetwork as keyof ExistingNetworks]}
                                                        onChange={(e) => {
                                                            handleCheck("expansionModif" + idNetwork, collaborator.coll_id, e.target.checked)
                                                        }}
                                                    />
                                                </td>
                                            </>
                                        )
                                    }
                                })}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
}
